import { LoadingButton } from '@mui/lab'
import { Button, Dialog, DialogActions, DialogContent, Box, Tooltip, IconButton } from '@mui/material'
import { FC } from 'react'
import { useMutation } from 'react-query'
import { backendClient } from '../../../../interactors/clients/client'
import { useGlobalSnackbarStore } from '../../../../store/GlobalSnackBarStore'
import { useDialogOpened } from '../../../../utils/hooks/useDialogOpened'
import { Delete } from '@mui/icons-material'
import { AnimalDocumentDto } from '../../../../interactors/gen/backendClient'

interface Props {
  documentId: string
  animalId: string
  setDocumentsList?: React.Dispatch<React.SetStateAction<AnimalDocumentDto[]>>
  disabled?: boolean
  iconOnly?: boolean
}

export const DeleteDocumentModal: FC<Props> = ({
  documentId,
  animalId,
  setDocumentsList,
  disabled,
  iconOnly = false,
}) => {
  const { isDialogOpen, openDialog, closeDialog } = useDialogOpened()
  const globalSnackbar = useGlobalSnackbarStore()

  // Mutation to delete the document
  const mutation = useMutation(async () => await backendClient.delete(`animals/${animalId}/documents/${documentId}`), {
    onSuccess: () => {
      globalSnackbar.triggerSuccessMessage(`Le document a bien été supprimé !`)
      setDocumentsList?.((prev) => prev.filter((document) => document.id !== documentId))
    },
  })

  return (
    <>
      <Tooltip
        title={disabled ? 'Vous ne pouvez pas supprimer les bons vétérinaire.' : 'Supprimer le document'}
        placement="top"
      >
        <span>
          {iconOnly ? (
            <IconButton
              size="small"
              sx={{
                color: 'error.main',
                width: { xs: 28, sm: 32 },
                height: { xs: 28, sm: 32 },
                borderRadius: 2,
                backgroundColor: 'rgba(220, 53, 69, 0.08)',
                '&:hover': { backgroundColor: 'rgba(220, 53, 69, 0.14)' },
              }}
              disabled={disabled}
              onClick={() => openDialog()}
            >
              <Delete sx={{ fontSize: { xs: 18, sm: 20 } }} />
            </IconButton>
          ) : (
            <Button sx={{ color: 'error.main' }} disabled={disabled} onClick={() => openDialog()}>
              <Delete />
            </Button>
          )}
        </span>
      </Tooltip>

      <Dialog open={isDialogOpen} onClose={closeDialog}>
        <DialogContent>
          <Box marginBottom={1}>Voulez vous vraiment supprimer ce document ?</Box>
        </DialogContent>
        <DialogActions>
          <Button data-testid="cancel" onClick={closeDialog}>
            Annuler
          </Button>
          <LoadingButton
            data-testid="apply-changes"
            variant="contained"
            onClick={() => mutation.mutate()}
            sx={{ backgroundColor: 'error.main' }}
            loading={mutation.isLoading}
          >
            Supprimer
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </>
  )
}
